import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ breakpoints, mixins, spacing, palette }) => ({
  navbar: {
    display: "flex !important",
    flexDirection: "row",
    justifyContent: "space-around",
    position: "relative",
  },
  logoContainer: {
    width: "30% !important",
  },
  logo: {
    width: "50% !important",
  },
  links: {
    gridColumn: "8/12",
    width: "42%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  offset: mixins.toolbar,
  active: {
    backgroundColor: palette.primary.main,
    borderRadius: "5px",
  },
  active2: {
    color: "white !important",
    fontFamily: "Source Sans Pro",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "16px",
    textTransform: "none!important",
    padding: "6px",
    textDecoration: "none!important",
    backgroundColor: "#997DB5 !important",
  },
  btn2: {
    textTransform: "none!important",
    fontFamily: "Source Sans Pro!important",
    fontStyle: "normal!important",
    fontWeight: "bold!important",
    fontSize: "16px!important",
  },
  inputfloat: {
    position: "absolute",
    right: "80px",
    top: "80px",
  },
}));

export default useStyles;
